const locale = {
	// #region Tabs
	TAB_LIST: 'List',
	TAB_DEFAULT_RECIPIENTS: 'Default recipients',
	// #endregion

	// #region DEMs fields
	DETAILS_DEMS_FIELD_TITLE: 'Title',
	DETAILS_DEMS_FIELD_DATE: 'Date',
	DETAILS_DEMS_FIELD_MARKETINGACTION: 'Origin Marketing Action',
	DETAILS_DEMS_FIELD_ASSIGNED_USER: 'Assigned User',
	DETAILS_DEMS_FIELD_ASSIGNED_GROUP: 'Assigned Group',
	DETAILS_DEMS_FIELD_WARNING: 'Warning',
	DETAILS_DEMS_FIELD_BLOCKED: 'Blocked',
	DETAILS_DEMS_FIELD_TAGS: 'Tags',
	// #endregion

	// #region DEMs filters
	DETAILS_DEMS_FIELD_STATUS: 'DEM Status',
	DETAILS_DEMS_FIELD_OPEN_COUNT: 'Opens count',
	DETAILS_DEMS_FIELD_CLICKS_COUNT: 'Clicks count',
	// #endregion

	DEMS_SETTINGS_DIALOG_TITLE: 'DEM settings',
	DETAILS_DEMS_FIELD_SUBJECT: 'Subject',
	DETAILS_DEMS_FIELD_PREVIEWTEXT: 'Preview text',
	DETAILS_DEMS_FIELD_SENDER_NAME: 'Sender name',
	DETAILS_DEMS_FIELD_SENDER_SURNAME: 'Sender surname',
	DETAILS_DEMS_FIELD_SENDER_MAIL: 'Sender e-mail',
	DETAILS_DEMS_FIELD_DEFAULT_LANGUAGE: 'Default message language',

	DEMS_RECIPIENTS_COLUMN_MAIL: 'Mail',
	DEMS_RECIPIENTS_COLUMN_ITEM: 'Linked item',
	DEMS_RECIPIENTS_COLUMN_DEM: 'DEM',
	DEMS_RECIPIENTS_COLUMN_STATUS: 'DEM Status',
	DEMS_RECIPIENTS_COLUMN_DATE: 'Date',
	DEMS_RECIPIENTS_COLUMN_CLICKS: 'Clicks',
	DEMS_RECIPIENTS_COLUMN_OPENS: 'Opens',
	DEMS_RECIPIENTS_COLUMN_UNSUBSCRIBED: 'Unsubscribed',
	DEMS_RECIPIENTS_COLUMN_BOUNCE: 'Bounce',

	DIALOG_TITLE_RECIPIENTS_OPEN_DETAILS: 'Open Details',
	DIALOG_TITLE_RECIPIENTS_CLICK_DETAILS: 'Click Details',

	DEMS_RECIPIENTS_TABLE_FOOTER_COUNTERS: 'Companies: {nCompanies} - People: {nPeople} - Users: {nUsers}',

	DEMS_URLS_COLUMN_LINK: 'Link',
	DEMS_URLS_COLUMN_CLICKS: 'Clicks',

	DEMS_MESSAGES_DIALOG_TITLE: 'Select the message to send',
	ALERT_MSG_OPEN_DEMS: 'Cannot perform this action',

	DIALOG_OPEN_DEMS_TITLE: 'Open DEMs',
	DIALOG_OPEN_DEMS_CONTENT: 'In order to create a new DEM you must close the existing one.',

	// #region Details DEM Manager section
	DEMS_MANAGER_SECTION: 'DEM Manager',
	DEMS_SELECT_CONNECTOR: 'Select connector',
	DEMS_SELECT_CONNECTOR_DESCRIPTION: '',
	DEMS_CONNECTOR_MAILUP: 'MailUp',
	DEMS_CONNECTOR_MAILCHIMP: 'MailChimp',
	DEMS_CONNECTOR_ERROR_NOT_LOGGED: 'You must connect your account to upload recipients',
	DEMS_ADD_RECIPIENTS: 'Add Recipients',
	DEMS_MAILUP_ADD_RECIPIENTS_DESCRIPTION:
		'The first step to preparing a DEM is to build the message through the MailUp editor. Then you can start to prepare the list of recipients manually or using the features here to mass enter Companies and/or People through filters present below.',
	DEMS_MAILCHIMP_ADD_RECIPIENTS_DESCRIPTION:
		'The first step to preparing a DEM is to build the message through the MailChimp editor. Then you can start to prepare the list of recipients manually or using the features here to mass enter Companies and/or People through filters present below.',
	DEMS_ACTION_BACK: 'Back',
	DEMS_UPLOAD_DEFAULT_RECIPIENTS: 'Upload Default recipients',
	DEMS_UPLOAD_RECIPIENTS: 'Upload',
	DEMS_SEND: 'Confirm send',
	DEMS_MAILUP_SEND_DESCRIPTION:
		'The email addresses have been uploaded to MailUp in a specific Group. When you want to confirm the sending/scheduling of the DEM press the "Send" button or the "Cancel" button to return to the previous step.',
	DEMS_MAILCHIMP_SEND_DESCRIPTION:
		'The email addresses have been uploaded to MailChimp in a specific Audience. When you want to confirm the sending/scheduling of the DEM press the "Send" button or the "Cancel" button to return to the previous step.',
	DEMS_ACTION_CANCELSEND: 'Cancel',
	DEMS_ACTION_SEND: 'Send',
	DEMS_SENDING: 'Sending in progress',
	DEMS_SENDING_DESCRIPTION: 'Scheduled delivery on {date}',
	DEMS_ACTION_UNSCHEDULE: 'Stop',
	DEMS_ACTION_CHECK_SEND_STATUS: 'Check status',
	DEMS_DOWNLOAD_STATS: 'Retrieve statistics',
	DEMS_MAILUP_DOWNLOAD_STATS_DESCRIPTION:
		'MailUp has begun the sending procedure, once completed it will be possible to update and synchronize the statistics of this DEM through the function "Retrieve Statistics". You can use this feature several times, so you can keep metrics always aligned with those available via MailUp.',
	DEMS_MAILCHIMP_DOWNLOAD_STATS_DESCRIPTION:
		'MailChimp has begun the sending procedure, once completed it will be possible to update and synchronize the statistics of this DEM through the function "Retrieve Statistics". You can use this feature several times, so you can keep metrics always aligned with those available via MailChimp.',
	DEMS_DOWNLOAD: 'Download',
	DEMS_UPDATE_STATS: 'Update statistics',
	DEMS_MAILCHIMP_DELETE_LIST: 'Delete audience from MailChimp',
	// #endregion

	// #region Details Dem Statistics section
	DEMS_NO_STATS: 'No statistics',
	DEMS_STATISTICS_SECTION: 'Statistics',
	DEMS_STATISTICS_TOTAL: 'Total',
	DEMS_STATISTICS_SENT: 'Sent',
	DEMS_STATISTICS_DELIVERED: 'Delivered',
	DEMS_STATISTICS_OPENED: 'Opened',
	DEMS_STATISTICS_CLICKED: 'Unique clicks',
	DEMS_STATISTICS_UNSUBSCRIBED: 'Unsubscribed',
	DEMS_STATISTICS_VALUE: 'Email marketing Quotations value',
	DEMS_STATISTICS_REVENUE: 'Email marketing revenue',
	// #endregion

	// #region Details Dem Add Recipients section
	DEMS_SECTION_ADD_TITLE: 'Add to list',
	DEMS_SECTION_ADD_RECIPIENT: 'Add',
	DEMS_SECTION_ADD_COMPANY: 'Company',
	DEMS_SECTION_ADD_PERSON: 'People',
	DEMS_SECTION_ADD_ALL: 'Company + People',
	DEMS_SECTION_ADD_MAIL: 'Mails',

	DEMS_SECTION_ADD_COMPANIES_TITLE: 'Add filtered Companies',
	DEMS_SECTION_ADD_PEOPLE_TITLE: 'Add filtered People',
	DEMS_SECTION_ADD_MAILS_TITLE: 'Add filtered Mails',

	DEMS_SECTION_COPY_TITLE: 'Import from',
	DEMS_SECTION_COPY_MARKETINGACTION: 'Marketing Action',
	DEMS_SECTION_COPY_DEM: 'DEM',
	DEMS_SECTION_COPY_COMMERCIALCAMPAIGN: 'Commercial Campaign',
	DEMS_SECTION_COPY_INCLUDE_ASSOCIATED_PEOPLE: "Include all linked People's mail addresses",

	DEMS_DIALOG_TITLE_ADD_RESULT: 'Do you want to add those Email addresses?',
	// #endregion

	// #region Details Dem Delete Rows section
	DEMS_SECTION_EMPTY_TITLE: 'Clear the list',
	DEMS_SECTION_EMPTY_DESCRIPTION: 'With this function you can clear the list (removing ALL the added elements)',
	DEMS_SECTION_EMPTY_BUTTON_CLEAR: 'Clear',
	// #endregion

	// #region DEMs Bounce types
	DIALOG_INFO_SB_TITLE: 'Soft Bounce',
	DIALOG_INFO_SB_TEXT:
		"This is a generic error, given when N:Bounce is unable to interpret the server's answer because it's not a standard or it is equivocal.",
	DIALOG_INFO_HB_TITLE: 'Hard Bounce',
	DIALOG_INFO_HB_TEXT:
		'The message had PERMANENT errors during delivery. These typically are wrong email addresses. After one or more unsuccessful deliveries the message is removed from the send queue, and the corresponding subscriber is unsubscribed.',
	DIALOG_INFO_SBDF_TITLE: 'Soft Bounce - DNS Faliure',
	DIALOG_INFO_SBDF_TEXT:
		"Problems with DNS. The message had PERMANENT delivery errors. It's an error given by the fact that the domain of the receiver (host) hasn't been solved in an equivalent valid IP. The cause could be temporary problems of the receiver's server, or that the destination domain doesn't exist or is written incorrectly.",
	DIALOG_INFO_SBMF_TITLE: 'Soft Bounce - Mailbox Full',
	DIALOG_INFO_SBMF_TEXT:
		"Mailbox is full. This message hasn't been delivered because the user's mailbox is temporarily exceeding its quota. These addresses should be removed from the Subscribers list only when the counter reaches a high number of errors compared with the number of deliveries.",
	DIALOG_INFO_GB_TITLE: 'General Bounce',
	DIALOG_INFO_GB_TEXT:
		'The message includes non-interpretable text parts. The message had PERMANENT delivery errors. After three delivery attempts, the message was removed from the send queue.',
	DIALOG_INFO_MB_TITLE: 'Mail Block',
	DIALOG_INFO_MB_TEXT:
		"The message includes non-interpretable text parts. The message had PERMANENT delivery errors. The receiver's mail server refused the message for an unspecified reason. See error details to have additional information.",
	DIALOG_INFO_TB_TITLE: 'Transient Bounce',
	DIALOG_INFO_TB_TEXT:
		"A temporary error: the delivery system found an error in the receiver's system, but it will try again. If the error persists, the system will give a Hard Bounce error.",
	DIALOG_INFO_MBRD_TITLE: 'Mail Block - Relay Denied',
	DIALOG_INFO_MBRD_TEXT:
		"The message had PERMANENT delivery errors. The message has been blocked by the receiver's mail system because it refuses the connection to the sender's server. Generally this happens when the SMTP server cannot be detected or when accounts just can't receive any external mail.",
	DIALOG_INFO_MBSD_TITLE: 'Mail Block - Spam Detected',
	DIALOG_INFO_MBSD_TEXT:
		"The message has been classified as Spam by the receiver's mail system. These bounces are less serious than the previous ones, but you still need to monitor them for they are not an encouraging sign. Generally, they are issued based on automatic rules. You should contact the receiver to try to understand why your message was considered spam.",
	// #endregion

	// #region Default recipients tab
	DEMS_DEFAULT_RECIPIENTS_ADD_TITLE: 'Select Mail',
	DEMS_DEFAULT_RECIPIENTS_ADD_BUTTON: 'Add recipient'
	// #endregion
};

export default locale;
